import Navbar from "../layouts/Navbar/Navbar"
import Sidebar from "../layouts/Sidebar/Sidebar"
import { useLocation } from 'react-router-dom'

const NavbarAndSidebar = () => {
  const location = useLocation()
  const currnetLocation = location.pathname
  return (
    currnetLocation === "/login" ?
      null :
      < div className='d-flex flex-column background h-100vh' >
        <Navbar />
        < div className='d-flex flex-row'>
          <Sidebar />
        </div>
      </div >
  )
}

export default NavbarAndSidebar